var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHulu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    zoomAndPan: "magnify",
    viewBox: "0 0 180 67.499998",
    height: 90,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "599f273387"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 7.238281 L 169.875 7.238281 L 169.875 60.097656 L 10 60.097656 Z M 10 7.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9161590c3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.128906 23.730469 L 27.003906 23.730469 C 25.539062 23.660156 24.078125 23.921875 22.730469 24.5 L 22.730469 7.238281 L 10.042969 7.238281 L 10.042969 60.097656 L 22.703125 60.097656 L 22.703125 38.769531 C 22.703125 37.863281 23.0625 36.992188 23.703125 36.351562 C 24.34375 35.710938 25.210938 35.355469 26.113281 35.359375 L 33.476562 35.359375 C 34.378906 35.355469 35.246094 35.710938 35.886719 36.351562 C 36.523438 36.992188 36.882812 37.863281 36.882812 38.769531 L 36.882812 60.097656 L 49.570312 60.097656 L 49.570312 37.105469 C 49.570312 27.433594 43.175781 23.730469 35.15625 23.730469 L 35.128906 23.730469 M 156.957031 23.730469 L 156.957031 45.058594 C 156.957031 46.941406 155.445312 48.46875 153.574219 48.46875 L 146.183594 48.46875 C 145.285156 48.476562 144.417969 48.121094 143.777344 47.480469 C 143.136719 46.839844 142.777344 45.96875 142.777344 45.058594 L 142.777344 23.730469 L 130.117188 23.730469 L 130.117188 46.117188 C 130.117188 55.289062 135.859375 60.097656 144.558594 60.097656 L 156.957031 60.097656 C 164.820312 60.097656 169.644531 54.417969 169.644531 46.195312 L 169.644531 23.730469 L 156.957031 23.730469 M 85.453125 45.058594 C 85.453125 45.96875 85.09375 46.839844 84.453125 47.480469 C 83.8125 48.121094 82.949219 48.476562 82.046875 48.46875 L 74.679688 48.46875 C 73.78125 48.476562 72.914062 48.121094 72.273438 47.480469 C 71.632812 46.839844 71.273438 45.96875 71.273438 45.058594 L 71.273438 23.730469 L 58.613281 23.730469 L 58.613281 46.117188 C 58.613281 55.289062 64.433594 60.097656 72.949219 60.097656 L 85.347656 60.097656 C 93.210938 60.097656 98.035156 54.417969 98.035156 46.195312 L 98.035156 23.730469 L 85.453125 23.730469 L 85.453125 45.058594 M 107.785156 60.097656 L 120.472656 60.097656 L 120.472656 7.238281 L 107.785156 7.238281 L 107.785156 60.097656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00716569,
    gradientTransform: "matrix(2.621104, 0, 0, 2.642924, 10.044494, 7.240215)",
    y1: 20.002892,
    x2: 15.536408,
    gradientUnits: "userSpaceOnUse",
    y2: -18.359369,
    id: "bab6c9b185"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.399048%, 74.499512%, 61.599731%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.583679%, 74.584961%, 61.572266%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.942261%, 74.754333%, 61.51886%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.288635%, 74.917603%, 61.46698%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.636536%, 75.080872%, 61.4151%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.984436%, 75.244141%, 61.36322%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.332336%, 75.40741%, 61.31134%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.680237%, 75.570679%, 61.25946%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.026611%, 75.733948%, 61.207581%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.374512%, 75.897217%, 61.155701%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.722412%, 76.060486%, 61.103821%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.070312%, 76.223755%, 61.051941%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.418213%, 76.38855%, 61.000061%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.764587%, 76.551819%, 60.948181%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.112488%, 76.715088%, 60.896301%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.460388%, 76.878357%, 60.844421%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.808289%, 77.041626%, 60.792542%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.154663%, 77.204895%, 60.740662%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.502563%, 77.368164%, 60.688782%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.850464%, 77.531433%, 60.636902%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.198364%, 77.694702%, 60.585022%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.546265%, 77.857971%, 60.533142%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.892639%, 78.02124%, 60.481262%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.24054%, 78.186035%, 60.429382%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.58844%, 78.349304%, 60.377502%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.93634%, 78.512573%, 60.325623%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.284241%, 78.675842%, 60.273743%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.630615%, 78.839111%, 60.221863%)",
    offset: 0.447942
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.804565%, 78.921509%, 60.195923%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.978516%, 79.00238%, 60.169983%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.326416%, 79.165649%, 60.118103%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.674316%, 79.328918%, 60.066223%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.022217%, 79.492188%, 60.014343%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.368591%, 79.655457%, 59.962463%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.716492%, 79.820251%, 59.910583%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.064392%, 79.983521%, 59.858704%)",
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.412292%, 80.14679%, 59.806824%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.758667%, 80.310059%, 59.754944%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.106567%, 80.473328%, 59.703064%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.454468%, 80.636597%, 59.651184%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.713867%, 80.758667%, 59.611511%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.799316%, 80.799866%, 59.599304%)",
    offset: 0.552058
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.799316%, 80.799866%, 59.599304%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.799316%, 80.799866%, 59.599304%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.799316%, 80.799866%, 59.599304%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.799316%, 80.799866%, 59.599304%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#599f273387)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9161590c3c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bab6c9b185)",
    d: "M 10.042969 7.238281 L 10.042969 60.097656 L 169.644531 60.097656 L 169.644531 7.238281 Z M 10.042969 7.238281 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHulu);
export default __webpack_public_path__ + "static/media/Hulu.da82d43d402297fdc7eb5d1a3a9c0b19.svg";
export { ForwardRef as ReactComponent };